// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEqamwtkE78quwvcSLMJsHuVFDJ-OJhSw",
  authDomain: "yiyaz-d3052.firebaseapp.com",
  projectId: "yiyaz-d3052",
  storageBucket: "yiyaz-d3052.appspot.com",
  messagingSenderId: "896185956602",
  appId: "1:896185956602:web:fb7339fe657078fabb3143",
  measurementId: "G-GFH42GSD4W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); 